import React from "react";
import { TacticState } from "./types";

export const TacticContext = React.createContext<TacticState | undefined>(
  undefined
);

export const useTactic = () => {
  const context = React.useContext(TacticContext);
  if (context === undefined) {
    throw new Error("useTactic must be used within a TacticProvider");
  }
  return context;
};
